import { reducer as flashReducer } from 'redux-flash'

import layout from 'shared/LayoutMain/reducer'
import user from 'shared/UserDropdown/reducers'
import retailer from './retailerReducer'

export default {
  layout,
  flash: flashReducer,
  retailer,
  user,
}
